

import XHeader from 'vux/src/components/x-header/index.vue'

export default {
components: {
XHeader
},
data () {
return {
show: false,
timer:'',
animate:0,
}
},
methods: {
changeAnimate() {
if(this.animate >= 2){
this.animate = 0
}else{
this.animate ++;
}
},
open(id){

this.$router.push('/learn/product/list?projectId='+id)
},
goUrl(id){
if(id==1){
this.$router.push('/learn/tryout')
}else{
this.$router.push('/learn/cooperation')
}
}
},
mounted() {
this.timer = setInterval(this.changeAnimate, 3000);
},
beforeDestroy() {
clearInterval(this.timer);
}

}



// WEBPACK FOOTER //
// ./src/views/learn/learnIndex.vue